export default "__VITE_ASSET__CQ971ZJ5__"